// 面试管理模块

//获取面试信息
function getInterviewInformation(jobid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { userid: Cookies.get("userid-b"), action: "edit", jobid, pagename: "bGetJobViewInfOnPoint" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取面试信息出错");
            resolve(false);
          }
        } else {
          console.log("获取面试信息出错");
          resolve(false);
        }
      }
    });
  });
}

//面试通过/拒绝
function manipulateInterview(CVID, pubid, status) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), pagename: "bsetviewstatus", CVID, pubid, status },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            console.log("面试操作失败");
            resolve(false);
          }
        } else {
          console.log("面试操作失败");
          resolve(false);
        }
      }
    });
  });
}

//职位审核通过
function identifyJobPublish(jobid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), entid: Cookies.get("userid-b"), pagename: "passWork", msg: { jobid } },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            console.log("职位审核通过失败");
            resolve(false);
          }
        } else {
          console.log("职位审核通过失败");
          resolve(false);
        }
      }
    });
  });
}

//职位审核拒绝
function refuseJobPublish(msg) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "save", userid: Cookies.get("userid-b"), entid: Cookies.get("entid-b"), pagename: "closeWork", msg },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            console.log("职位拒绝失败");
            resolve(false);
          }
        } else {
          console.log("职位拒绝失败");
        }
      }
    });
  });
}

//获取审核的职位列表
function verityJob(countnum = 10, currpage = 1) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "edit", userid: Cookies.get("userid-b"), entid: Cookies.get("userid-b"), countnum, currpage, pagename: "bWorkProgress" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取审核的职位列表出错");
            resolve(false);
          }
        } else {
          console.log("获取审核的职位列表出错");
          resolve(false);
        }
      }
    });
  });
}

//获取所有职位列表
function getTotalJobList(data) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "edit", userid: Cookies.get("userid-b"), entid: Cookies.get("userid-b"), countNum: data.countnum, currpage: data.currpage, status: data.status, pagename: "bGetAllJobList", qerystr: JSON.stringify(data.searchinfor) },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            let jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve({ msg: jsonRes.msg, totalnum: jsonRes.totalnum ? jsonRes.totalnum : 0 }) : resolve(false);
          } catch (e) {
            console.log("获取所有职位列表出错");
            resolve(false);
          }
        } else {
          console.log("获取所有职位列表出错");
          resolve(false);
        }
      }
    });
  });
}

//获取推送历史
function deliveryHistory(pageCount = 10, currPage = 1) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "edit", userid: Cookies.get("userid-b"), pageCount, currPage, Bdate: "2019-1-1", Edate: "2222-10-10", pagename: "bGetPassHistory" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取推送历史出错");
            resolve(false);
          }
        } else {
          console.log("获取推送历史出错");
          resolve(false);
        }
      }
    });
  });
}

export default {
  getInterviewInformation,
  manipulateInterview,
  identifyJobPublish,
  refuseJobPublish,
  verityJob,
  getTotalJobList,
  deliveryHistory
};
